let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g759n")).then(() => parcelRequire('dxWU3'));